import img1 from './01-hero.jpeg';
import img2 from './02-agent-constellation.png';
import img3 from './03-use-cases.jpeg';
import img4 from './04-pattern-deck.jpeg';
import img5 from './05-about.jpeg';
import img6 from './06-faq.jpeg';
import img7 from './07-mobile.jpeg';

const images = {
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
};

export default images;
